import { DEFAULT_CODE_PATTERN, type CodePattern } from '@fluenceur/types';

/**
 * No pattern means the default one. The builder already renders null as
 * `DEFAULT_CODE_PATTERN`, so a program switching the custom format off is
 * moving to the default rather than to nothing: comparing raw nulls would call
 * that move "unchanged" and skip the question the brand must be asked.
 */
export const normalizeCodePattern = (pattern: CodePattern | null | undefined): CodePattern =>
  pattern ?? DEFAULT_CODE_PATTERN;

/** Deep equality over the three fields a pattern is made of. */
export const hasCodePatternChanged = (
  saved: CodePattern | null | undefined,
  next: CodePattern | null | undefined
): boolean => {
  const before = normalizeCodePattern(saved);
  const after = normalizeCodePattern(next);

  if (before.separator !== after.separator) return true;
  if (before.uppercase !== after.uppercase) return true;
  if (before.parts.length !== after.parts.length) return true;

  return before.parts.some((part, index) => {
    const other = after.parts[index];
    return part.type !== other.type || (part.value ?? '') !== (other.value ?? '');
  });
};
